module.exports = __webpack_public_path__ + "static/media/A1-21-Uzen-cod119.0ff3cd4b.png";